import { defineField, defineType } from 'sanity'
import { buttonThemeFields } from '../objects/buttonThemeFields'

export default defineType({
  name: 'team',
  title: 'Team',
  type: 'object',
  fields: [
    defineField({
      name: 'heading',
      title: 'Heading',
      type: 'string',
    }),
    defineField({
      name: 'people',
      title: 'People',
      type: 'array',
      of: [
        {
          type: 'reference',
          title: 'Author reference',
          to: [
            {
              type: 'author',
            },
          ],
          options: {
            filter: ({ parent }) => {
              const excludeList = parent.map((author: any) => author._ref)

              return {
                filter:
                  '_type == "author" && !(_id in path("drafts.**")) && !(_id in $excludeList)',
                params: {
                  excludeList,
                },
              }
            },
          },
        },
        {
          name: 'placeholder',
          title: 'CTA Placeholder',
          type: 'object',
          fields: [
            defineField({
              name: 'heading',
              title: 'Heading',
              type: 'string',
            }),
            defineField({
              name: 'link',
              title: 'Link',
              type: 'link',
            }),
          ],
          preview: {
            select: {
              title: 'heading',
            },
            prepare({title}) {
              return {
                title,
                subtitle: 'Placeholder'
              }
            }
          }
        },
      ],
      validation: (rule) => [rule.required(), rule.min(1), rule.unique()],
    }),
    defineField({
      name: 'viewMoreButton',
      title: 'View more button',
      type: 'object',
      fields: [
        defineField({
          name: 'threshold',
          title: 'Threshold',
          type: 'number',
          initialValue: 6,
        }),
        ...buttonThemeFields,
      ],
    }),
  ],
  preview: {
    select: {
      heading: 'heading',
      people: 'people',
    },
    prepare({ heading, people }) {
      let subtitle = 'Team'

      if (people?.length) {
        subtitle += ` - ${people.length} people`
      }

      return {
        title: heading || 'Team',
        subtitle,
      }
    },
  },
})
